import DDWAdminIndex from "../components/ddw-admin/DDWAdminIndex";
import FileUploadAdminPage from "../components/ddw-admin/FileUploadAdmin/FileUploadAdminPage";
import FileUploadIndex from "../components/portal/FileUploadIndex";
import FileUploadMgmtPage from "../components/ddw-admin/fileUploadMgmt/FileUploadMgmtPage";
import FileUploadReviewPage from "../components/ddw-admin/fileUploadMgmt/FileUploadReviewPage";
import UserManagementPage from "../components/ddw-admin/UserManagement/UserManagementPage";
import UserReportPage from "../components/ddw-admin/UserReport/UserReportPage";
import IPSViolationAdmin from "../components/rulesAndEnforcements/IPSViolationAdmin";

export const ddwAdminRoutes = [
  {
    path: "/ddw-admin/ddw-admin-index",
    component: DDWAdminIndex
  },
  {
    path: "/ddw-admin/file-upload/file-upload-management",
    component: FileUploadMgmtPage
  },
  {
    path: "/ddw-admin/file-upload/file-upload-review",
    component: FileUploadReviewPage
  },
  {
    path: "/ddw-admin/file-upload/file-upload-admin",
    component: FileUploadAdminPage
  },
  { 
    path: "/ddw-admin/file-upload-index", 
    component: FileUploadIndex 
  },
  {
    path: "/ddw-admin/user-management",
    component: UserManagementPage
  },
  {
    path: "/ddw-admin/user-management/:umd_id",
    component: UserManagementPage
  },
  {
    path: "/ddw-admin/user-report",
    component: UserReportPage
  },
  {
    path: "/RulesandEnforce/ips-violations-admin",
    component: IPSViolationAdmin
  }
];
